import { accountFeaturesUrl } from "./endpoints.js";
const accountFeaturesCacheKey = ({
  accountId,
  accountIdType
}) => [accountFeaturesUrl, { accountId, accountIdType }];
export {
  accountFeaturesCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
